import { AxiosResponse } from 'axios'
import axios from '@/services/axios'

export default abstract class TransactionsApi {
  public static route = process.env.VUE_APP_SHOP_BASE_URI
  public static entity = 'transactions'

  public static async get(params: string): Promise<AxiosResponse> {
    return await axios.get(`${this.route}/${this.entity}?${params}`)
  }

  public static async restore(
    id: bigint,
    data: object,
  ): Promise<AxiosResponse> {
    return await axios.post(`${this.route}/${this.entity}/${id}`, data)
  }
}
